import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table
} from 'reactstrap'


class DeleteTVModal extends PureComponent {
    
    constructor(props) {
        super(props);
        this.onDeleteClick = this.onDeleteClick.bind(this);
    }

    
    onDeleteClick(businessID) {
        return e => {
            e.stopPropagation();
            this.props.onDeleteTV(businessID)
        };
    }

    renderResults() {
        return this.props.tvList.map(tv => (
        <tr
            key={tv.id}
            className="user-table__item"
        >
            <td className="text-center">
                {tv.otherOptions.TVName ? tv.otherOptions.TVName : <i>No Name</i>}
            </td>
            <td className="text-center">
                {tv.id}
            </td>
            <td className="text-center">
                <Button
                onClick={this.onDeleteClick(tv.id)}
                color="danger"
                >
                Delete this TV
                </Button>
            </td>
        </tr>
        ));
    }


    render() {
        return (
            
        <Modal
            isOpen={this.props.open}
            toggle={this.toggle}
            className={this.props.className}
        >
            {this.props.open ? (
            <div>
                <ModalHeader toggle={this.props.close}>Delete a TV for {this.props.selectedBusiness.name}</ModalHeader>
                <ModalBody>
                {this.props.tvList.length ? (
                        <Table
                        hover
                        responsive
                        className="table-outline mb-0 d-none d-sm-table user-table"
                        >
                        <thead className="thead-light">
                            <tr>
                            <th className="text-center">Name</th>
                            <th className="text-center">TV ID</th>
                            <th className="text-center">Delete</th>
                            </tr>

                            {this.renderResults()}
                        </thead>
                        <tbody />
                        </Table>
                    ) : <div>This business has no GoNation TVs.</div>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={this.props.onClose}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </div>
            ): null}
        </Modal>
        
        )
    }
}
export default DeleteTVModal;


// WEBPACK FOOTER //
// ./src/views/Components/Modals/DeleteTVModal.js